// ** Redux Imports
import { combineReducers } from 'redux';

// ** Reducers Imports
import addresses from './addresses';
import loyaltyPointsConsumption from './loyalty-points-consumption';
import charges from './charges';
import orders from './orders';
import orderEvents from './order-events';
import invoices from './invoices';
import returnInvoices from './return-invoices';

const merchantReducer = combineReducers({
  addresses,
  loyaltyPointsConsumption,
  charges,
  orders,
  orderEvents,
  invoices,
  returnInvoices,
});

export default merchantReducer;
